import React from 'react';
import HeroSection from '../components/home/HeroSection';
import PracticeAreas from '../components/home/PracticeAreas';
import AboutSection from '../components/home/AboutSection';
import TeamSection from '../components/home/TeamSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import ContactSection from '../components/home/ContactSection';

const Home = () => {
    return (
        <div>
        <HeroSection />
        <PracticeAreas />
        <AboutSection />
        <TeamSection />
        <TestimonialsSection />
        <ContactSection />
        </div>
    );
};

export default Home;